import { Collection, Logger, LogManager } from "@mcleod/core";

export class LayoutCache {
    private static readonly cache: Collection<string> = {};
    private static log: Logger;

    public static get(name: string): string {
        return this.cache[name];
    }

    public static isCached(name: string): boolean {
        return this.get(name) != null;
    }

    public static put(name: string, layoutDefinition: string) {
        this.getLog().debug("Putting layout %s into cache: %o", name, layoutDefinition);
        this.cache[name] = layoutDefinition;
    }

    public static putAll(otherCache: Collection<string>) {
        if (otherCache != null) {
            for (const name of Object.keys(otherCache)) {
                const value = otherCache[name];
                this.getLog().debug("Putting layout %s into cache (from existing cache): %o", name, value);
                this.put(name, value);
            }
        }
    }

    public static clearAll() {
        this.getLog().debug("Clearing all cached layouts");
        for (const name of Object.keys(this.cache)) {
            delete this.cache[name];
        }
    }

    public static clear(name: string): void {
        this.getLog().debug("Clearing cached layout: %s", name);
        delete this.cache[name];
    }

    public static getCopy(): Collection<string> {
        return { ...this.cache };
    }

    public static isEmpty(): boolean {
        return Object.keys(this.cache).length === 0;
    }

    private static getLog(): Logger {
        if (this.log == null) {
            this.log = LogManager.getLogger("components.layout.LayoutCache");
        }
        return this.log;
    }
}
